/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-DUAqv8gi.js";
import { t } from "./css-build-DcREbovZ.js";
import { i as n, n as r, r as i, t as a } from "./uberblick-BTeECFFb.js";
import { t as o } from "./decorateMetadata-BXz2gmG4.js";
import { t as s } from "./decorate-C_HUHFGG.js";
import { LitElement as c, html as l } from "lit";
import { customElement as u, property as d } from "lit/decorators.js";
// \0lit-plugin:css-sheet:./src/elements/product-logo/product-logo.css.js
var f = t(":host{line-height:0;display:inline-block}:host>img{object-fit:contain;width:100%;max-width:100%;height:100%;max-height:100%;filter:var(--darkmode-filter-reversal);display:block}"), p = {
	intratool: {
		url: i,
		label: "Intratool"
	},
	uberblick: {
		url: a,
		label: "Überblick"
	},
	horeca: {
		url: n,
		label: "Horeca Hero"
	},
	onboard: {
		url: r,
		label: "Onboard"
	}
}, m = class extends e(c) {
	constructor(...e) {
		super(...e), this.product = "intratool", this.styles = f;
	}
	render() {
		let { url: e, label: t } = p[this.product];
		return l`<img src=${e} alt=${t} />`;
	}
};
s([d({ reflect: !0 }), o("design:type", Object)], m.prototype, "product", void 0), m = s([u("ptc-ui-product-logo")], m);
export { m as t };

//# sourceMappingURL=product-logo-CHlh10WN.js.map